import React from "react";

import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {observer} from "mobx-react";

export const NewSearchWidgetSportsFilterListItem = observer(({controller, sport, onMouseEnter, isHighlighted}) => {
  const {config: {source}} = controller;

  const itemProps = {
    className: classNames(styles.sport_item, {[styles.item_hover] : isHighlighted}),
    onMouseEnter,
    onClick: () => {
      controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeClick, {id: sport.id , source})
      controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: false})
    }
  }

  return <div {...itemProps}>{sport.name}</div>
});
